(function () {
  /* ===============================
     CONFIG PADRÃO
     (usado só se o elemento #formula-bar não tiver os data-attributes
     vindos do schema do Customizer)
  =============================== */

  const DEFAULTS = {
    threshold1: 500,
    threshold2: 1000,
    thresholdShipping: 100,
    coupon1: 'FORMULA30',
    coupon2: 'FORMULA40',
    couponShipping: 'FRETEGRATIS',
    textBelow: 'Faltam {{valor}} em Fórmulas para <strong>30% OFF</strong>',
    textMid: 'Faltam {{valor}} em Fórmulas para <strong>40% OFF</strong>',
    textDone: 'Você desbloqueou <strong>40% OFF + Frete Grátis!</strong>'
  };

  const BLOCKED_FORMULA_PRODUCTS = [
    8969421848733,
    8393409888413,
    8984063443101,
    8882112168093,
    8551740342429
  ];

  const UPSELL_SELECTORS = [
    '.cart-drawer_upsell.upsell-list'
  ];

  let lastRenderedSubtotal = -1;
  let lastTier = null;
  let debounceTimer = null;
  let fetchHooked = false;
  let domObserverStarted = false;
  let blockedProductDetected = false;

  /* ===============================
     HELPERS
  =============================== */

  function norm(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function urlHasAnySlug(urlStr, slugs) {
    const u = norm(urlStr);

    if (!u) return false;

    return slugs.some((s) => {
      const slug = norm(s);

      return (
        u.includes('/products/' + slug) ||
        u.includes(slug)
      );
    });
  }

  function getProductId(item) {
    return Number(
      (item && item.product_id) || 0
    );
  }

  function getItemHandle(item) {
    return norm(item && item.handle);
  }

  function getItemUrl(item) {
    return norm(item && item.url);
  }

  function isBlockedProduct(item) {
    if (!item) return false;

    const productId = getProductId(item);

    return BLOCKED_FORMULA_PRODUCTS.includes(
      productId
    );
  }

  function isFormulaProduct(item) {
    if (!item) return false;

    // Apenas produtos bloqueados NÃO contabilizam
    return !isBlockedProduct(item);
  }

  const currencyFormatter =
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

  function formatCents(cents) {
    return currencyFormatter.format(
      Math.max(0, Number(cents) || 0) / 100
    );
  }

  function getConfig(bar) {
    const ds = (bar && bar.dataset) || {};

    const min30 = parseFloat(ds.min30);
    const min40 = parseFloat(ds.min40);
    const minShipping = parseFloat(
      ds.minShipping
    );

    return {
      threshold1Cents: Math.round(
        (
          Number.isFinite(min30) &&
          min30 > 0
            ? min30
            : DEFAULTS.threshold1
        ) * 100
      ),

      threshold2Cents: Math.round(
        (
          Number.isFinite(min40) &&
          min40 > 0
            ? min40
            : DEFAULTS.threshold2
        ) * 100
      ),

      thresholdShippingCents: Math.round(
        (
          Number.isFinite(minShipping) &&
          minShipping > 0
            ? minShipping
            : DEFAULTS.thresholdShipping
        ) * 100
      ),

      coupon1:
        ds.coupon30 ||
        DEFAULTS.coupon1,

      coupon2:
        ds.coupon40 ||
        DEFAULTS.coupon2,

      couponShipping:
        ds.couponShipping ||
        DEFAULTS.couponShipping,

      textBelow:
        ds.textBelow ||
        DEFAULTS.textBelow,

      textMid:
        ds.textMid ||
        DEFAULTS.textMid,

      textDone:
        ds.textDone ||
        DEFAULTS.textDone
    };
  }

  /* ===============================
     CART
  =============================== */

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin'
    });

    return response.json();
  }

  function computeFormulaSubtotalCents(cart) {
    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return 0;
    }

    return cart.items.reduce(
      (total, item) => {
        // Ignora apenas os produtos bloqueados
        if (isBlockedProduct(item)) {
          return total;
        }

        /*
         * Usa o valor original da linha,
         * antes dos descontos.
         *
         * Exemplo:
         * Produto de R$ 500 com 30% OFF
         * continua contabilizando R$ 500
         * para a barra.
         */
        const lineTotal = Number(
          (
            item.original_line_price != null
              ? item.original_line_price
              : item.line_price
          ) || 0
        );

        return total + lineTotal;
      },
      0
    );
  }

  function hasBlockedProductInCart(cart) {
    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return false;
    }

    return cart.items.some((item) =>
      isBlockedProduct(item)
    );
  }

  function applyCoupon(code) {
    return fetch(
      '/discount/' +
        encodeURIComponent(code),
      {
        credentials: 'same-origin'
      }
    ).catch(() => null);
  }

  function removeCoupon() {
    return fetch('/discount/', {
      credentials: 'same-origin'
    }).catch(() => null);
  }

  /* ===============================
     VISIBILITY
  =============================== */

  function setElHidden(el, hidden) {
    if (!el) return;

    el.style.display = hidden
      ? 'none'
      : '';

    el.setAttribute(
      'aria-hidden',
      hidden ? 'true' : 'false'
    );
  }

  function setUpsellHidden(hidden) {
    UPSELL_SELECTORS.forEach(
      (selector) => {
        document
          .querySelectorAll(selector)
          .forEach((el) => {
            setElHidden(el, hidden);
          });
      }
    );
  }

  function setFormulaBarHidden(hidden) {
    const bar =
      document.getElementById(
        'formula-bar'
      );

    setElHidden(bar, hidden);
  }

  /* ===============================
     RENDER
  =============================== */

  function determineTier(
    subtotalCents,
    cfg
  ) {
    if (
      subtotalCents >=
      cfg.threshold2Cents
    ) {
      return 3;
    }

    if (
      subtotalCents >=
      cfg.threshold1Cents
    ) {
      return 2;
    }

    if (
      subtotalCents >=
      cfg.thresholdShippingCents
    ) {
      return 1;
    }

    return 0;
  }

  function renderBar(
    subtotalCents,
    cfg,
    hasBlocked
  ) {
    const bar =
      document.getElementById(
        'formula-bar'
      );

    if (!bar) return false;

    const fill = bar.querySelector(
      '#formula-progress-fill'
    );

    const ball = bar.querySelector(
      '#formula-progress-ball'
    );

    const status = bar.querySelector(
      '#formula-status'
    );

    const text = bar.querySelector(
      '#formula-text'
    );

    if (
      !fill ||
      !ball ||
      !status ||
      !text
    ) {
      return false;
    }

    /*
     * Atualiza a barra e a bolinha.
     *
     * A porcentagem é calculada com base
     * no subtotal original dos produtos.
     */
    const percent =
      Math.max(
        0,
        Math.min(
          subtotalCents /
            cfg.threshold2Cents,
          1
        )
      ) * 100;

    fill.style.width =
      percent + '%';

    ball.style.left =
      percent + '%';

    let template;
    let remainingCents;

    if (
      subtotalCents <
      cfg.threshold1Cents
    ) {
      template = cfg.textBelow;

      remainingCents =
        cfg.threshold1Cents -
        subtotalCents;

      status.textContent =
        formatCents(subtotalCents) +
        ' / ' +
        formatCents(
          cfg.threshold1Cents
        );
    } else if (
      subtotalCents <
      cfg.threshold2Cents
    ) {
      template = cfg.textMid;

      remainingCents =
        cfg.threshold2Cents -
        subtotalCents;

      status.textContent =
        formatCents(subtotalCents) +
        ' / ' +
        formatCents(
          cfg.threshold2Cents
        );
    } else {
      template = cfg.textDone;
      remainingCents = 0;

      status.textContent =
        formatCents(subtotalCents);
    }

    text.innerHTML =
      template.replace(
        '{{valor}}',
        '<strong>' +
          formatCents(remainingCents) +
          '</strong>'
      );

    bar.setAttribute(
      'data-rendered-subtotal',
      String(subtotalCents)
    );

    /*
     * Atualiza os marcos.
     */
    const milestoneShipping =
      bar.querySelector(
        '#formula-milestone-shipping'
      );

    const milestone30 =
      bar.querySelector(
        '#formula-milestone-30'
      );

    const milestone40 =
      bar.querySelector(
        '#formula-milestone-40'
      );

    if (milestoneShipping) {
      milestoneShipping.classList.toggle(
        'is-reached',
        subtotalCents >=
          cfg.thresholdShippingCents
      );
    }

    if (milestone30) {
      milestone30.classList.toggle(
        'is-reached',
        subtotalCents >=
          cfg.threshold1Cents
      );
    }

    if (milestone40) {
      milestone40.classList.toggle(
        'is-reached',
        subtotalCents >=
          cfg.threshold2Cents
      );
    }

    /*
     * Mantém a função de mensagem
     * dos produtos bloqueados.
     */
    if (
      typeof renderBlockedMessage ===
      'function'
    ) {
      renderBlockedMessage(hasBlocked);
    }

    return true;
  }

  async function syncDiscountState(
    tier,
    cfg
  ) {
    if (lastTier === tier) return;

    lastTier = tier;

    if (tier === 0) {
      await removeCoupon();
    } else if (tier === 1) {
      await applyCoupon(
        cfg.couponShipping
      );
    } else if (tier === 2) {
      await applyCoupon(
        cfg.coupon1
      );
    } else {
      await applyCoupon(
        cfg.coupon2
      );
    }
  }

  async function updateFormulaBar() {
    const bar =
      document.getElementById(
        'formula-bar'
      );

    if (!bar) return;

    const cfg = getConfig(bar);
    const cart = await getCart();

    /*
     * Retorna o subtotal original
     * dos produtos elegíveis.
     */
    const subtotalCents =
      computeFormulaSubtotalCents(cart);

    const hasBlocked =
      hasBlockedProductInCart(cart);

    setFormulaBarHidden(false);
    setUpsellHidden(false);

    const renderedSubtotal = Number(
      bar.getAttribute(
        'data-rendered-subtotal'
      )
    );

    const needsRender =
      !Number.isFinite(
        renderedSubtotal
      ) ||
      renderedSubtotal !==
        subtotalCents;

    if (
      subtotalCents !==
        lastRenderedSubtotal ||
      needsRender ||
      blockedProductDetected !==
        hasBlocked
    ) {
      lastRenderedSubtotal =
        subtotalCents;

      blockedProductDetected =
        hasBlocked;

      renderBar(
        subtotalCents,
        cfg,
        hasBlocked
      );
    }

    /*
     * O cupom também é definido
     * pelo subtotal original.
     */
    const tier = determineTier(
      subtotalCents,
      cfg
    );

    await syncDiscountState(
      tier,
      cfg
    );
  }

  function scheduleUpdate(delay) {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(
      updateFormulaBar,
      Number(delay || 120)
    );
  }

  /* ===============================
     OBSERVERS
  =============================== */

  function observeFormulaBarInDom() {
    if (domObserverStarted) return;

    domObserverStarted = true;

    const observer =
      new MutationObserver(() => {
        const bar =
          document.getElementById(
            'formula-bar'
          );

        if (!bar) return;

        if (
          bar.getAttribute(
            'data-rendered-subtotal'
          ) == null
        ) {
          scheduleUpdate(0);
          return;
        }

        scheduleUpdate(120);
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function observeCartDrawer() {
    const drawer =
      document.querySelector(
        'cart-drawer'
      );

    if (!drawer) return;

    const observer =
      new MutationObserver(() => {
        scheduleUpdate(120);
      });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  /* ===============================
     FETCH HOOK
  =============================== */

  function hookFetchOnce() {
    if (fetchHooked) return;

    fetchHooked = true;

    const originalFetch =
      window.fetch;

    window.fetch = function () {
      return originalFetch
        .apply(this, arguments)
        .then((response) => {
          try {
            const url = String(
              (
                response &&
                response.url
              ) || ''
            );

            if (
              url.includes('/cart/add') ||
              url.includes('/cart/change') ||
              url.includes('/cart/update') ||
              url.includes('/cart/clear')
            ) {
              scheduleUpdate(100);
            }
          } catch (error) {}

          return response;
        });
    };
  }

  /* ===============================
     INIT
  =============================== */

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      observeFormulaBarInDom();
      observeCartDrawer();
      hookFetchOnce();
      scheduleUpdate(0);
    }
  );
})();